import log from 'salvo-lite/log'
import $ from 'jquery'

class AddToCart {
    constructor (theme, elem) {
        this._elem = elem
        this._atcBtns = elem.querySelectorAll('.ProductItem__Atc')
        this._cartCountEl = document.querySelector('.Header__CartCount')
        this._cartOpenBtn = document.querySelector('a[data-drawer-id="sidebar-cart"]')
    }

    onInit () {
        log.debug(this.constructor.name, 'Initialising...', this)
        this._atcBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault()

                let variantEl = btn.closest('[data-variant-id]').dataset.variantId
                let variantId = parseInt(variantEl)

                $.post('/cart/add.js', {
                    quantity: 1,
                    id: variantId
                }, () => {
                    this._increaseCartCount()

                    $.get(window.location.pathname, (response) => {
                        let newPage = document.createElement('html')
                        newPage.innerHTML = response
                        let oldForm = document.querySelector('.Cart.Drawer__Content')
                        let newForm = newPage.querySelector('.Cart.Drawer__Content')
                        oldForm.innerHTML = newForm.innerHTML
                        this._cartOpenBtn.click()
                    }, null, 'html')
                }, 'json').fail((data) => {
                    alert(data.responseJSON.description)
                })
            })
        })
    }

    _increaseCartCount () {
        let cartCount = parseInt(this._cartCountEl.textContent)
        this._cartCountEl.textContent = cartCount + 1
    }
}

export default AddToCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/AddToCart.js